import { Component } from '@angular/core';
import { MdcService } from 'src/app/shared/mdc/mdc.service';

@Component({
  selector: 'app-step-section-vi',
  templateUrl: './step-section-vi.component.html',
})
export class StepSectionVIComponent {
  constructor(public mdcService: MdcService) { }
}
